<template>
  <div
    :style="styles"
    class="ps-dom-highlight ps-border-solid ps-border-8 ps-absolute ps-opacity ps-pointer-events-none"
  ></div>
</template>

<script>
export default {
  name: 'DomHighlight',
  props: {
    rect: {
      type: DOMRect,
      default: () => {}
    }
  },
  computed: {
    styles() {
      if (!this.rect) return
      return {
        width: `${this.rectPadded.width}px`,
        height: `${this.rectPadded.height}px`,
        top: `${this.rectPadded.top}px`,
        left: `${this.rectPadded.left}px`
      }
    },
    rectPadded() {
      return {
        width: this.rect.width + 40,
        height: this.rect.height + 40,
        top: this.rect.top - 20,
        left: this.rect.left - 20
      }
    }
  }
}
</script>

<style scoped>
.ps-dom-highlight {
  opacity: 0.75 !important;
  border-color: rgba(159 183 10, 0.9) !important;
  box-shadow: 0 0 0px 20px rgba(159 183 10, 0.25) !important;
}
</style>